import React, { useState, useEffect, useMemo } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { ChevronDownSvg } from "../../svgFiles/ChevronDownSvg";
import { getGlassTypeOptions } from "../../helpers/Utils";

const glassType = [
  { label: "Full set", value: "F" },
  { label: "Glasses only", value: "G" },
  { label: "Lenses only", value: "L" },
  { label: "Sunglasses only", value: "S" },
  { label: "Charging cable", value: "C" },
];


const Glassonly = ({ label, value, onSelect, disabled = false, productType, skuName }) => {
  const [selected, setSelected] = useState(null);



  const glassTypeOptions = useMemo(
    () => getGlassTypeOptions({ productType, skuName }),
    [productType, skuName]
  );




  // ✅ Sync with value prop
  useEffect(() => {
    if (value) {
      const found = glassTypeOptions.find(
        (t) => t.value === value || t.label === value
      );
      setSelected(found || null);
    } else {
      setSelected(null);
    }
  }, [value, glassTypeOptions]);



  const handleSelect = (type) => {
    setSelected(type);
    onSelect?.(type?.value || null);
  };



  // ✅ Decide what text to show
  const displayText = selected ? (
    <>
      <span className="text-start">{selected.label} :</span>
      <span className="sortLabel me-auto">{selected.value}</span>
    </>
  ) : (
    <span className="flex-grow-1 text-start">{label || "Select option"}</span>
  );

  return (
    <Dropdown className={`custoom-dropdown w-100 statusDrop${disabled ? " is-disabled" : ""}`}>
      <Dropdown.Toggle
        disabled={disabled}
        id="custom-dropdown"
        variant="unset"
        className="d-flex justify-content-between align-items-center w-100 btn-height-lg"
        style={disabled ? { cursor: "not-allowed" } : undefined}
      >
        {displayText}
        <ChevronDownSvg />
      </Dropdown.Toggle>

      <Dropdown.Menu className="w-100">
        {/* {glassType.map((type) => (
          <Dropdown.Item
            className="d-flex justify-content-between"
            key={type.value}
            onClick={() => handleSelect(type)}  // 🔹 closes dropdown automatically
            active={selected?.value === type.value}
          >
            <span className="bar">{type.label}</span>
            <span className="sortLabel">{type.value}</span>
          </Dropdown.Item>
        ))} */}

        {glassTypeOptions.map((type) => (
          <Dropdown.Item
            key={type.value}
            className="d-flex justify-content-between"
            onClick={() => handleSelect(type)}
            active={selected?.value === type.value}
          >
            <span>{type.label}</span>
            <span className="sortLabel">{type.value}</span>
          </Dropdown.Item>
        ))}


      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Glassonly;
